import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=2b12288c&scoped=true&"
import script from "./TransactionView.vue?vue&type=script&lang=ts&"
export * from "./TransactionView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=2b12288c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12288c",
  null
  
)

export default component.exports